// extracted by mini-css-extract-plugin
export default {"root":"CoursePauseModalSuccessStage_root__oa5p7","success":"CoursePauseModalSuccessStage_success__4Myrc"};